// extracted by mini-css-extract-plugin
module.exports = {"layout":"bar-chart_layout__6fr1D","field":"bar-chart_field__WOXs3","barContainer":"bar-chart_barContainer__vS_Wy","bar":"bar-chart_bar__ZKDBv","value":"bar-chart_value__uBOvX"};